function toCount(value) {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
}

const csMessageReminder = {
  namespaced: true,
  state: {
    unreadTotal: 0,
    unreadCount: 0,
    pendingCount: 0
  },
  mutations: {
    SET_COUNTS(state, payload) {
      state.unreadCount = toCount(payload.unreadCount)
      state.pendingCount = toCount(payload.pendingCount)
      const total = toCount(payload.unreadTotal)
      state.unreadTotal = total > 0 ? total : state.unreadCount + state.pendingCount
    },
    SET_UNREAD_TOTAL(state, total) {
      const n = Number(total)
      state.unreadTotal = Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
    }
  },
  actions: {
    updateCounts({ commit }, payload) {
      commit('SET_COUNTS', payload)
    },
    updateUnreadTotal({ commit, state }, total) {
      commit('SET_UNREAD_TOTAL', total)
      if (!state.unreadCount && !state.pendingCount) {
        commit('SET_COUNTS', { unreadCount: 0, pendingCount: 0, unreadTotal: total })
      }
    }
  }
}

export default csMessageReminder
